<!-- Localized -->
<template>
    <div class="p-8 rounded-lg bg-white">
        <div
            class="flex items-center justify-center flex-1 bg-card-bg rounded-md gap-2"
            v-if="loading"
        >
            <loader class="my-5" :size="8" />{{ $t('pages.field_table.loading') }}
        </div>
        <div class="flex flex-col gap-4" v-else>
            <div class="font-bold text-2xl pb-4 border-b border-gray-400"> {{ fieldLabel }} </div>
            <div class="p-4 rounded-lg bg-gray-100" v-html="fieldBody"></div>
        </div>
    </div>
</template>

<script>
import axios from '@/axios'
import { mapGetters } from "vuex";
import loader from "@shared/loader";

export default {
  name: 'footer-content',
  components: {
    loader,
  },
  data() {
    return {
      fieldLabel: '',
      fieldBody: '',
      loading: false
    }
  },
  created() {
  },
  async mounted() {
    await this.fetchTenantFieldDetails()
  },
  title: "Footer content",
  computed: {
    ...mapGetters(["getIsClient", "getClientId", "getTenantId"]),
  },
  watch: {
  },
  methods: {
    async fetchTenantFieldDetails() {
      this.loading = true
      try {
        // let id;
        // if (this.getIsClient) {
        //   id = this.getClientId;
        // } else {
        //   id = this.getTenantId;
        // }

        const fieldId = this.$route.params['id'];
        const response = await axios.get(`fields/${fieldId}`)
        if (response.data) {
          this.fieldLabel = response.data.label || ''
          this.fieldBody = response.data.placeholder || ''
        }
      } catch (error) {
        console.error('Error fetching tenant field details:', error)
      } finally {
        this.loading = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>